import axios from "axios";
const jsonConfig = require("../../Config.json");
const getJobDescriptionById = async (jdId) => {
  try {
    const response = await axios.get(
      `${jsonConfig.apiUrl}getjdbyid`,
      {
        params: { jdId },
        headers: {
          "x-functions-key": jsonConfig.key,
        },
      }
    );
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
export default getJobDescriptionById;